<template>
  <div id="app">
    <div class="all container">
      <SiteHeader />
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import SiteHeader from './components/SiteHeader'

export default {
  name: 'app',
  components: {
    SiteHeader
  }
}
</script>

<style>
body {
  background-color: #011;
}

.all {
  background-color: #ccc;
  margin-top: 2rem;
  margin-bottom: 2rem;
  padding: 5rem 2rem;
}

#app {
  font-family: 'Lato', Helvetica, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 16px;
  margin-top: 60px;
}

/* hr */
hr {
  margin: 2rem 10rem 3rem 10rem;
  border-color: #111;
}

/* Buttons */
.button,
input[type="submit"].button {
  background-color: #111;
  color: white;
  font-size: 1.4rem;
  font-family: "Unica One";
  transition: background-color 300ms ease-out;
  border-radius: 0;
}

.button:hover,
  input[type="submit"].button:hover {
  background-color: #ccc;
  color: #111;
}
</style>



// WEBPACK FOOTER //
// App.vue?10dcc9ca